module.exports = __webpack_public_path__ + "img/card.57a26b86.png";